import { render } from "./ProsesPelaksanaan.vue?vue&type=template&id=17a4f3a4"
import script from "./ProsesPelaksanaan.vue?vue&type=script&lang=js"
export * from "./ProsesPelaksanaan.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__